<template>
  <div id="addClassify">
    <div class="commodityHead row">
      <el-button size="small" style="width: 100px" type="primary" @click="open"
        >添加分类</el-button
      >
    </div>
    <div class="content">
      <!-- 表格 -->
      <div>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            align="center"
            prop="supplierClassificationName"
            label="分类"
            width="180"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column align="right" label="操作">
            <template slot-scope="scope">
              <el-button size="small" class="button5" @click="open2(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="small"
                type="danger"
                class="button5"
                @click="open3(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div v-if="tableData" class="block" style="float: right; margin-top: 10px">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="pageVal"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="totalNumber"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  supplierClassificationList,
  supplierClassificationListTotal,
  saveSupplierClassification,
  modifySupplierClassification,
  deleteSupplierClassification,
} from "../api";
export default {
  data() {
    return {
      tableData: [],
      totalNumber: 0,
      pageVal: 1, //分页页码
      isShow: true,
    };
  },
  created() {
    this.supplierClassificationList();
  },
  methods: {
    open() {
      this.$prompt("添加分类", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value.length > 20) {
            this.$message.error("分类名称不建议超过20个字哦~");
            return;
          }
          this.saveSupplierClassification(value);
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "取消输入"
          // });
        });
    },
    open2(e) {
      if (e.supplierClassificationId == 0) {
        this.$message.error("默认分类不能编辑");
        return;
      }
      this.$prompt("编辑分类名", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: e.supplierClassificationName,
      })
        .then(({ value }) => {
          this.modifySupplierClassification(value, e.supplierClassificationId);
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "取消输入"
          // });
        });
    },
    open3(e) {
      if (e.supplierClassificationId == 0) {
        this.$message.error("默认分类不能删除");
        return;
      }
      this.$confirm("此操作将永久删除该分类, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(({ value }) => {
          this.deleteSupplierClassification(e.supplierClassificationId);
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "取消输入"
          // });
        });
    },
    //添加分类
    saveSupplierClassification(e) {
      saveSupplierClassification({
        supplierClassificationName: e,
      })
        .then((res) => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "已添加分类名：" + e,
            });
            this.supplierClassificationList();
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log("error");
        });
    },
    //编辑分类
    modifySupplierClassification(supplierClassificationName, supplierClassificationId) {
      console.log(supplierClassificationName, supplierClassificationId);
      if (supplierClassificationName == "" || supplierClassificationName.length > 20) {
        this.$message.error("请输入分类名并分类名不能超过20个字哦~");
        return;
      }
      // return
      modifySupplierClassification({
        supplierClassificationName: supplierClassificationName,
        supplierClassificationId: supplierClassificationId,
      })
        .then((res) => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "分类名修改为：" + supplierClassificationName,
            });
            this.supplierClassificationList();
            console.log(this.tableData, "编辑分类");
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log("error");
        });
    },
    //删除分类
    deleteSupplierClassification(supplierClassificationId) {
      deleteSupplierClassification({
        supplierClassificationId: supplierClassificationId,
      })
        .then((res) => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "删除分类成功",
            });
            this.supplierClassificationList();
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log("error");
        });
    },
    //分页当前页
    handleCurrentChange(val) {
      this.pageVal = val;
      this.supplierClassificationList(); //供应商列表
    },
    //供应商分类列表
    supplierClassificationList(e) {
      supplierClassificationList({
        pageNo: this.pageVal,
        row: 10,
      })
        .then((res) => {
          if (res.code == 1) {
            this.tableData = res.data;
            supplierClassificationListTotal({
              pageNo: this.pageVal,
              row: 10,
            })
              .then((res) => {
                if (res.code == 1) {
                  this.totalNumber = res.data.totalNum;
                } else if (res.code == 2) {
                  this.$message.error(res.msg);
                  this.$router.push("/");
                } else {
                  this.$message.error(res.msg);
                }
              })
              .catch((res) => {
                console.log("error");
              });
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {
          console.log("error");
        });
    },
  },
};
</script>

<style scoped>
.commodityHead {
  box-sizing: border-box;
  width: calc(100vw - 200px);
  padding: 15px 20px 15px 30px;
  background: #f8f8f8;
  z-index: 99;
}
.content {
  position: absolute;
  top: 110px;
  width: calc(100vw - 217px);
  box-sizing: border-box;
  padding: 25px;
}
</style>
